import { render, staticRenderFns } from "./OnBoardingForm.vue?vue&type=template&id=4e9ee9d1&"
import script from "./OnBoardingForm.vue?vue&type=script&lang=js&"
export * from "./OnBoardingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports